import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import type { ExpenseCategory, OurWorkCategory } from "../models";
import type { TCategory } from "../types";

interface CategoryNavigationProps {
  ourWorkCategories: OurWorkCategory[];
  expenseCategories: ExpenseCategory[];
  selected: TCategory;
  onSelect: (category: TCategory) => void;
}

const CategoryNavigation = (props: CategoryNavigationProps) => {
  return (
    <NavBar>
      <NavBar.Item
        active={props.selected === undefined}
        underline={false}
        onClick={() => props.onSelect(undefined)}
      >
        <Trans>All types</Trans>
      </NavBar.Item>

      {props.ourWorkCategories.map((category) => (
        <NavBar.Item
          key={category.budget_category_id}
          underline={false}
          active={
            props.selected?.type === "ourWork" &&
            props.selected?.id === category.budget_category_id
          }
          onClick={() =>
            props.onSelect({
              type: "ourWork",
              id: category.budget_category_id,
            })
          }
        >
          {category.name}
        </NavBar.Item>
      ))}

      {props.expenseCategories.map((category) => (
        <NavBar.Item
          key={category.budget_category_id}
          underline={false}
          active={
            props.selected?.type === "expense" &&
            props.selected?.id === category.budget_category_id
          }
          onClick={() =>
            props.onSelect({
              type: "expense",
              id: category.budget_category_id,
            })
          }
        >
          {category.name}
        </NavBar.Item>
      ))}
    </NavBar>
  );
};

export default observer(CategoryNavigation);
